import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap-icons/font/bootstrap-icons.css";
import store from "./store"; // Import the store
import { Provider } from "react-redux";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <div role="presentation" aria-hidden="true">
      <GoogleReCaptchaProvider
        reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      >
        <Provider store={store}>
          <App />
        </Provider>
      </GoogleReCaptchaProvider>
    </div>

    <div aria-label="Security verification using Google reCAPTCHA"></div>
  </>
);
window.addEventListener("error", (e) => {
  const message = e?.message || "";
  if (message.includes("Loading chunk") && message.includes("failed")) {
    console.warn("Chunk load failed. Reloading the page...");
    window.location.reload(); // fallback: reload to fetch new chunks
  }
});

window.addEventListener("unhandledrejection", (event) => {
  if (event.reason && event.reason.name === "ChunkLoadError") {
    const chunkFailedMessage = /Loading chunk (\d+) failed/;
    const match = event.reason.message.match(chunkFailedMessage);

    if (match) {
      const chunkId = match[1];
      console.warn(`Chunk ${chunkId} failed to load, retrying...`);

      // Force reload the page after a short delay
      setTimeout(() => {
        window.location.reload(true);
      }, 1000);

      event.preventDefault();
    }
  }
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals())
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
